import { render, staticRenderFns } from "./FilesManager.vue?vue&type=template&id=5cba7332"
import script from "./FilesManager.vue?vue&type=script&lang=js"
export * from "./FilesManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports